import React, {useState} from 'react';
import {Box} from '@mui/material';
import {Link} from 'react-router-dom';
import ArrButton from '../../../components/common/arr-button/ArrButton';
import {ArrDrawer} from '../../../components/common/arr-drawer/ArrDrawer';

const DrawerDemo: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Box className="demo-page banner-demo">
      <h1>ARR Drawer</h1>
      <div>
        <h1>Large Screen</h1>

        <ArrButton
          type="submit"
          variant="primary"
          size="medium"
          title="Drawer"
          onClick={() => setIsOpen(true)}
          dataTestId="drawer-demo-open-right-drawer-button">
          Open Right Drawer
        </ArrButton>
        <ArrDrawer
          transition={300}
          showButton={true}
          isOpen={isOpen}
          size="large"
          side="right"
          onClose={() => setIsOpen(false)}
        />
      </div>
      <Link to="/demo" className="link">
        Return
      </Link>
    </Box>
  );
};

export default DrawerDemo;
